import React, { Component } from "react";
import { Col, Icon, Row } from "antd";
import { PropTypes } from 'prop-types';
import guideStarLogo from "../../../../assets/icons/GuideStar-logo.svg";
import { Box } from "../../styles";
import FilterSlider from "../FilterSlider/FilterSlider";
import { BottomWrapper, CloseText, PoweredBy } from "./styles";
import { recordError } from "../../../../utils/commonUtil";

export default class Financials extends Component {

    valueChange = (values, key, max) => {
      this.props.updateStateFunc(values, key, max);
    };

    formatter(value) {
      return "$" +
      Number(value).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
      });
    }

  closeFunc = (index) => {
    try {
      this.props.closeOption(index);
    } catch (error) {
      recordError(error);
    }
  };

  handleClick =(e)=>{
    try {
      if(this.node.contains(e.target)){
        return
      }
      let elem = document.querySelector('.FinPopup');
      elem.style.display = 'none';
    } catch (error) {}
  }

  render() {
    return (
      <Box  className="FinPopup" ref={node=> this.node = node } left={this.props.isFull? 96 : 95}>
        <Row gutter={16}>
        <Col className="gutter-row" lg={8}>
          <FilterSlider
          key="form990_total_revenue"
          title="Revenue (F990)"
          slideValues={(values, max) =>
          this.valueChange(values, "form990_total_revenue", max)
          }
          minValue={this.props.tabFilters.form990_total_revenue.min}
          maxValue={this.props.tabFilters.form990_total_revenue.max}
          min={0}
          max={500000000}
          tipFormatter={this.formatter}
          />
          </Col>
          <Col className="gutter-row" lg={8}>
          <FilterSlider
          key="form990_total_expenses"
          title="Total Expenses"
          slideValues={(values, max) => {
          this.valueChange(values, "form990_total_expenses", max)
          }
          }
          minValue={this.props.tabFilters.form990_total_expenses.min}
          maxValue={this.props.tabFilters.form990_total_expenses.max}
          min={0}
          max={500000000}
          tipFormatter={this.formatter}
          />
          </Col>
          <Col className="gutter-row" lg={8}>
          <FilterSlider
          key="form990_total_assets"
          title="Total Assets"
          slideValues={(values, max) =>
          this.valueChange(values, "form990_total_assets", max)
          }
          minValue={this.props.tabFilters.form990_total_assets.min}
          maxValue={this.props.tabFilters.form990_total_assets.max}
          min={0}
          max={500000000}
          tipFormatter={this.formatter} f
          />
          </Col>
        </Row>
        <Row gutter={16}>
        <BottomWrapper>
          <PoweredBy><span>Powered By</span><img src={guideStarLogo} alt="Vangaurd" /></PoweredBy>
          <CloseText
          data-test="closeText"
            key="closeText"
            onClick={index => this.closeFunc(this.props.index)}
          >
            Close <Icon type="close" />
          </CloseText>
        </BottomWrapper>
        </Row>
      </Box>
    );
  }
}

const basicPropType = PropTypes.shape({
  min: PropTypes.number,
  max: PropTypes.number,
})

Financials.propTypes = {
  closeOption: PropTypes.func,
  fromPage: PropTypes.string,
  geminiFilterData: PropTypes.func,
  index: PropTypes.number,
  isFull: PropTypes.bool,
  sliderStatus: PropTypes.func,
  tabFilters: PropTypes.shape({
    form990_total_assets: basicPropType,
    form990_total_expenses: basicPropType,
    form990_total_revenue: basicPropType,
  }),
  updateStateFunc: PropTypes.func,
}
